import { render, staticRenderFns } from "./ActTab.vue?vue&type=template&id=53d0c3a2&scoped=true"
import script from "./ActTab.vue?vue&type=script&lang=js"
export * from "./ActTab.vue?vue&type=script&lang=js"
import style0 from "./ActTab.vue?vue&type=style&index=0&id=53d0c3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0c3a2",
  null
  
)

export default component.exports